<div fxLayout="column" *ngIf="!visualize">
  <div fxLayout="row">
    <p>Afficher les documents avec une DUA sans durée&nbsp;</p>
    <mat-slide-toggle
      [checked]="toggleDUAwoDurationChecked"
      (change)="toggleDUAwoDuration($event.checked)"
      [disabled]="toggleOnlyBELChecked"
    ></mat-slide-toggle>
  </div>

  <div fxLayout="row">
    <p>Afficher les documents avec une DUA conservation&nbsp;</p>
    <mat-slide-toggle
      [checked]="toggleDUAConservationChecked"
      (change)="toggleDUAConservation($event.checked)"
      [disabled]="toggleOnlyBELChecked"
      matTooltip="/!\ On ne tient pas compte de la durée de la DUA car cela concerne des documents qui sont à détruire de manière exceptionnelle (document devenu illisible suite à des dégats des eaux etc.)"
    ></mat-slide-toggle>
  </div>

  <div fxLayout="row">
    <p>Afficher uniquement les documents du BEL&nbsp;</p>
    <mat-slide-toggle
      [checked]="toggleOnlyBELChecked"
      (change)="toggleOnlyBEL($event.checked)"
    ></mat-slide-toggle>
  </div>
</div>

<ng-container *ngIf="!toggleOnlyBELChecked && docList.length > 0">
  <div class="docs-actions ck">
    <ng-container *ngIf="docList.length === docsChecked">
      <span>Décocher tous les documents de la page ({{docList.length}}) <mat-icon (click)="massUpdate()">check_box</mat-icon></span>
    </ng-container>
    <ng-container *ngIf="docList.length > docsChecked">
      <span>Cocher tous les documents de la page ({{docList.length}}) <mat-icon (click)="massUpdate()">check_box_outline_blank</mat-icon></span>
    </ng-container>
  </div>
</ng-container>

<app-data-table *ngIf="extraParams" #dataTable
                [dataSource]="dsDocuments"
                [urlBaseOverride]="urlListDocuments"
                [extraParams]="extraParams"
                [extraDict]="extraDict"
                [flexAction]="10" [flexColumn]="90"
                [pageSize]="25" [pageSizesList]="[25,50,100]"
                [placeHolderFilter]="'Rechercher un document'"
                [toolTipFilter]="'Rechercher un document'"
                [minFilter]="2"
                [filterDisplay]="false"
                [refreshButton]="null"
                [refreshIcone]="null"
                [columns]="columns"
                [actions]="actions"
                [showLoader]="true"
                [loaderMask]="true"
                [loaderProgress]="true"
                [showFirstLastButtons]="true"
                [colorHeaderBackground]="'#f3f3f3'"
                [colorHeader]="'black'">
</app-data-table>
